module.exports = __webpack_public_path__ + "static/carousel-0-sm-49a337350f3cac8aa78088404a1c4f20.png";